export var FileProcessingStatus;
(function (FileProcessingStatus) {
    FileProcessingStatus["Succeeded"] = "SUCCEEDED";
    FileProcessingStatus["Failed"] = "FAILED";
    FileProcessingStatus["Running"] = "RUNNING";
})(FileProcessingStatus || (FileProcessingStatus = {}));
